import React, { Component } from "react";

import { calculateCustomerPrice, CustomerDiscountTypes } from "../../utils/customerPriceCalculator";

import "./customerPriceCalculator.css";

class CustomerPriceCalculator extends Component {
  state = {
    pricePerMapPart: "400000",
    discountEnabled: false,
    discountType: CustomerDiscountTypes.FIXED_PER_MAP_PART,
    discountValue: "50000",
  };

  formatNumber = (value) => {
    return new Intl.NumberFormat("de-DE", {
      maximumFractionDigits: 0,
    }).format(Math.round(value));
  };

  onNumberInputChange = (fieldName) => (event) => {
    const cleanedValue = event.target.value.replace(/[^\d.]/g, "");
    this.setState({ [fieldName]: cleanedValue });
  };

  applyStreamerDiscountExample = () => {
    this.setState({
      discountEnabled: true,
      discountType: CustomerDiscountTypes.FIXED_PER_MAP_PART,
      discountValue: "50000",
    });
  };

  renderDiscountInputLabel() {
    const { discountType } = this.state;
    switch (discountType) {
      case CustomerDiscountTypes.FIXED_PER_MAP_PART:
        return "Rabatt pro Kartenteil";
      case CustomerDiscountTypes.PERCENTAGE:
        return "Rabatt in %";
      case CustomerDiscountTypes.MANUAL_TOTAL:
        return "Gesamtrabatt";
      default:
        return "Rabatt";
    }
  }

  render() {
    const { optionValue_mapSize_x, optionValue_mapSize_y } = this.props;
    const { pricePerMapPart, discountEnabled, discountType, discountValue } = this.state;
    const mapParts = optionValue_mapSize_x * optionValue_mapSize_y;
    const price = calculateCustomerPrice({
      pricePerMapPart,
      mapParts,
      discountEnabled,
      discountType,
      discountValue,
    });

    return (
      <div className="section customerPriceDiv">
        <h2>Kundenpreis</h2>
        <div className="customerPriceGrid">
          <label>
            <span>Preis pro Kartenteil</span>
            <input type="number" min="0" step="1000" value={pricePerMapPart} onChange={this.onNumberInputChange("pricePerMapPart")} />
          </label>
          <div className="customerPriceMetric">
            <span>Kartenteile</span>
            <strong>{`${optionValue_mapSize_x}x${optionValue_mapSize_y} = ${price.mapParts}`}</strong>
          </div>
        </div>

        <div className="customerPriceExamples">
          <button type="button" onClick={this.applyStreamerDiscountExample}>
            Streamer-Rabatt
          </button>
        </div>

        <label className="customerDiscountToggle">
          <input type="checkbox" checked={discountEnabled} onChange={(event) => this.setState({ discountEnabled: event.target.checked })} />
          <span>Rabatt aktivieren</span>
        </label>

        {discountEnabled ? (
          <div className="customerPriceGrid">
            <label>
              <span>Rabattart</span>
              <select value={discountType} onChange={(event) => this.setState({ discountType: event.target.value })}>
                <option value={CustomerDiscountTypes.FIXED_PER_MAP_PART}>Fix pro Kartenteil</option>
                <option value={CustomerDiscountTypes.PERCENTAGE}>Prozentual</option>
                <option value={CustomerDiscountTypes.MANUAL_TOTAL}>Manueller Gesamtrabatt</option>
              </select>
            </label>
            <label>
              <span>{this.renderDiscountInputLabel()}</span>
              <input type="number" min="0" step="1000" value={discountValue} onChange={this.onNumberInputChange("discountValue")} />
            </label>
          </div>
        ) : null}

        <div className="customerPriceSummary">
          <div>
            <span>Gesamtpreis</span>
            <strong>{this.formatNumber(price.subtotal)}</strong>
          </div>
          <div>
            <span>Rabatt</span>
            <strong>{this.formatNumber(price.discountTotal)}</strong>
          </div>
          <div className="customerPriceFinal">
            <span>Endpreis</span>
            <strong>{this.formatNumber(price.finalTotal)}</strong>
          </div>
        </div>
      </div>
    );
  }
}

export default CustomerPriceCalculator;
